import Checkout from "../order/Checkout";
import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MetaComponent from "../components/MetaComponent";
import api from "../../shared/AxiosConfig";
// import Hero from "./home/Hero";

const metadata = {
    title: `Checkout Success || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function CheckoutPage({ onPageReady }) {

    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");
    const [order, setOrder] = useState(null);

    useEffect(() => {
        const fetchOrder = async () => {
            if (!sessionId) return;

            try {
                const res = await api.get(`/payment/order/by-session/${sessionId}`);
                setOrder(res.data.order);
                onPageReady?.();
            } catch (err) {
            }
        };

        fetchOrder();
    }, [sessionId]);


    if (!order) return <div className="container py-5">Yükleniyor...</div>;

    return (
        <>
            <MetaComponent meta={metadata}/>
            <Header/>
            <>
                {/* Breadcrumb */}
                <div className="flat-spacing pb-0">
                    <div className="container">
                        <div className="title-success-order text-center">
                            <img className="icon" src="../../images/section/success.svg" alt=""/>
                            <div className="box-title">
                                <h3 className="title">Thank you for your order!</h3>
                                <p className="text-md text-main">You are awesome, Vineta! Thank you so much for your
                                    purchase.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}

                {/* /Title Page */}
            </>
            {/* Order Confirmation Layout */}
            <div className="flat-spacing-29 mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8">
                            <div className="tf-main-success">
                                {/* Order Summary */}
                                {/* Order Summary */}
                                <div className="box-progress-order">
                                    <div className="order-progress-item order-code text-center">
                                        <div className="title text-sm fw-medium">Order number</div>
                                        <div className="text-md fw-medium code">#{order.orderNumber}</div>
                                    </div>
                                    <div className="order-progress-item order-date text-center">
                                        <div className="title text-sm fw-medium">Order date</div>
                                        <div
                                            className="text-md fw-medium date">{new Date(order.orderDate).toLocaleDateString('en-US', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric'
                                        })}</div>
                                    </div>
                                    <div className="order-progress-item order-total text-center">
                                        <div className="title text-sm fw-medium">Order total</div>
                                        <div className="text-md fw-medium total">£{order.totalPrice.toFixed(2)}</div>
                                    </div>
                                    <div className="order-progress-item payment-method text-center">
                                        <div className="title text-sm fw-medium">Payment method</div>
                                        <div className="text-md fw-medium metod">Card</div>
                                        {/* Stripe için sabit */}
                                    </div>
                                </div>


                                {/* Order Timeline */}
                                <div className="box-timeline-order">
                                    <div className="timeline-item active text-center">
                                        <div className="box-icon"><span className="icon icon-confirm"/></div>
                                        <div className="content">
                                            <div className="title fw-medium text-md">Confirmed</div>
                                            <span
                                                className="date fw-medium text-sm text-main">{new Date(order.orderDate).toLocaleDateString('en-US', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })}</span>
                                        </div>
                                    </div>
                                    <div className="line-time"/>
                                    <div className="timeline-item text-center">
                                        <div className="box-icon"><span className="icon icon-shipped"/></div>
                                        <div className="content">
                                            <div className="title fw-medium text-md">Shipped</div>
                                            <span className="date fw-medium text-sm text-main">
                                            {new Date(new Date(order.orderDate).getTime() + 10 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })}</span>
                                        </div>
                                    </div>
                                    <div className="line-time"/>
                                    <div className="timeline-item text-center">
                                        <div className="box-icon"><span className="icon icon-location"/></div>
                                        <div className="content">
                                            <div className="title fw-medium text-md">Delivered</div>
                                            <span className="date fw-medium text-sm text-main">{new Date(new Date(order.orderDate).getTime() + 16 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })}</span>
                                        </div>
                                    </div>
                                </div>


                                {/* Shipping & Billing */}
                                {/* Shipping & Billing */}
                                <div className="box-ship-address">
                                    <div className="row justify-content-between">
                                        <div className="col-12 col-sm-5">
                                            <div className="ship-address-item">
                                                <div className="text-lg fw-medium title">Shipping address</div>
                                                <ul className="list-address">
                                                    <li className="text-sm text-main">{order.shippingAddress.fullName}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.phoneNumber}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.addressLine1}</li>
                                                    {order.shippingAddress.addressLine2 && (
                                                        <li className="text-sm text-main">{order.shippingAddress.addressLine2}</li>
                                                    )}
                                                    <li className="text-sm text-main">{order.shippingAddress.city}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.country || "United Kingdom"}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.postcode}</li>

                                                </ul>
                                            </div>
                                        </div>
                                        {/* Billing adresi eşit ise kopyala veya boş bırakılabilir */}
                                        <div className="col-12 col-sm-5">
                                            <div className="ship-address-item billing mb-0">
                                                <div className="text-lg fw-medium title">Billing address</div>
                                                <ul className="list-address">
                                                    <li className="text-sm text-main">{order.shippingAddress.fullName}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.phoneNumber}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.addressLine1}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.city}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.country || "United Kingdom"}</li>
                                                    <li className="text-sm text-main">{order.shippingAddress.postcode}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-xl-4">
                            <div className="tf-page-cart-sidebar sidebar-order-success">
                                <div className="cart-box order-box">
                                    <div className="title text-lg fw-medium">Order Details</div>
                                    <ul className="list-order-product">
                                        {order.items.map((item, index) => (
                                            <li key={index} className="order-item">
                                                <figure className="img-product">
                                                    <img
                                                        src={item.coverImage || "/images/placeholder.jpg"} // fallback görsel
                                                        alt={item.name}
                                                    />
                                                    <span className="quantity">{item.quantity}</span>
                                                </figure>
                                                <div className="content">
                                                    <div className="info">
                                                        <p className="name text-sm fw-medium">{item.name}</p>
                                                        <span className="variant">{item.size} / {item.gender}</span>
                                                    </div>
                                                    <span
                                                        className="price text-sm fw-medium">£{item.unitPrice.toFixed(2)}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>

                                    <ul className="list-total">
                                        <li className="total-item text-sm d-flex justify-content-between">
                                            <span>Subtotal:</span>
                                            <span
                                                className="price-sub fw-medium">£{order.totalItemPrice.toFixed(2)}</span>
                                        </li>
                                        <li className="total-item text-sm d-flex justify-content-between">
                                            <span>Tax:</span>
                                            <span className="price-tax fw-medium">£{order.totalTax.toFixed(2)}</span>
                                        </li>
                                        <li className="total-item text-sm d-flex justify-content-between">
                                            <span>Shipping:</span>
                                            <span
                                                className="price-ship fw-medium">£{order.totalShippingCost.toFixed(2)}</span>
                                        </li>
                                    </ul>

                                    <div className="subtotal text-lg fw-medium d-flex justify-content-between">
                                        <span>Total:</span>
                                        <span className="total-price-order">£{order.totalPrice.toFixed(2)}</span>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <Footer/>
        </>
    );
}
